import React, { Component } from 'react';
import Shiitake from 'shiitake';
import { isString, every } from 'lodash';
import REGEX from '../../constants/regex';

class Text extends Component {
  constructor(props) {
    super(props);
    this.isString = isString(props.children);
    // There are cases where we want to opt out from using Shiitake which only
    // supports strings and word-breaks at white spaces only. This does not play
    // well with Japanese strings and non-string props.children. This might
    // change as new versions of Shiitake are released.
    this.renderUsingShiitake = every([
      this.isString,
      !REGEX.JAPANESE_CHARACTERS.test(props.children),
    ]);
  }

  static defaultProps = {
    lines: 3,
  };

  componentDidMount() {
    if (this.renderUsingShiitake) return;

    try {
      $clamp(this.nodeRef, { clamp: this.props.lines });
    } catch (error) {
      if (this.isString) {
        this.renderUsingShiitake = true;
      } else {
        // forcing React to render a new span using a new key in case $clamp
        // messes up the original span at the first render
        this.fallbackRenderKey = 'fallback-render';
      }
      this.forceUpdate();
    }
  }

  render() {
    const { className, lines, children } = this.props;
    return this.renderUsingShiitake ? (
      <Shiitake lines={lines} className={className} children={children} />
    ) : (
      <span
        key={this.fallbackRenderKey}
        className={className}
        ref={n => {
          this.nodeRef = n;
        }}
        children={children}
      />
    );
  }
}

export default Text;
